/*
 * Помеченные ссылки из рекламы: klichat.ru/go/<код> или ?c=<код>.
 *
 * Код запоминаем при заходе и держим месяц: человек прочитал пост, зашёл, посмотрел, а
 * зарегистрировался на следующий день — регистрация всё равно должна засчитаться каналу.
 * Заходы на сайт считаем сами, без сторонних счётчиков: один запрос на загрузку страницы,
 * без cookie, с обезличенным случайным идентификатором браузера — он нужен только чтобы
 * отличить сто заходов одного человека от ста разных.
 */
import { api } from '@/lib/api'

const KEY = 'klichat.campaign'
const VID = 'klichat.vid'
const TTL = 30 * 86400000
const CODE = /^[a-z0-9_-]{2,32}$/i

/** Забрать код из адреса и запомнить. Зовётся один раз при запуске, до роутера. */
export function catchCampaign(): void {
  try {
    const url = new URL(window.location.href)
    const path = /^\/go\/([a-z0-9_-]{2,32})\/?$/i.exec(url.pathname)?.[1]
    const code = (path ?? url.searchParams.get('c') ?? '').toLowerCase()
    if (!code || !CODE.test(code)) return
    localStorage.setItem(KEY, JSON.stringify({ code, until: Date.now() + TTL }))
    // адрес чистим: код не должен уехать дальше по ссылкам
    window.history.replaceState(null, '', '/')
  } catch {
    /* без хранилища — без атрибуции */
  }
}

export function campaign(): string {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return ''
    const { code, until } = JSON.parse(raw) as { code: string; until: number }
    if (!code || Date.now() > until) return ''
    return code
  } catch {
    return ''
  }
}

function visitorId(): string {
  try {
    let id = localStorage.getItem(VID)
    if (!id) {
      id = crypto.randomUUID()
      localStorage.setItem(VID, id)
    }
    return id
  } catch {
    return ''
  }
}

const tracked = new Set<string>()

/** Заход на страницу: считаем лендинг, вход и регистрацию — по одному разу за загрузку. */
export function trackVisit(pathname: string): void {
  const path = pathname === '/' ? '/' : pathname.startsWith('/register') ? '/register' : pathname.startsWith('/login') ? '/login' : ''
  if (!path || tracked.has(path)) return
  tracked.add(path)
  void api<void>('/metrics/visit', {
    method: 'POST',
    keepalive: true,
    body: JSON.stringify({ path, campaign: campaign(), referrer: document.referrer.slice(0, 200), vid: visitorId() }),
  }).catch(() => {
    /* статистика не должна мешать человеку */
  })
}
